export default [
  'mercadoPagoCard',
  'mercadoPagoCardMX',
  'mercadoPagoCardCO',
  'stripeMX',
  'kushkiPE',
  'kushkiCO',
  'kushkiCOPSE',
  'kushkiCL',
  'kushkiAsyncCL',
  'kushkiWebpay',
  'webpayOneClick',
  'webpayOneClickTest',
  'webpayOrioneat',
  'webpayTest',
  'khipu',
  'webpay',
  'webpayCurry',
  'orion',
  'amipass',
  'sodexo',
  'mach',
  'chek',
  'fpay',
  'payUCOCard',
  'fpayPE',
  'kushkiEC',
  'proSuenos',
  'epaymentsCR',
  'paypalMX',
  'placeToPayCardEC',
  'bankTransfer'
]
